import { z } from 'zod';
/**
 * Query request for RAG-based Bible queries.
 */
export const QueryRequestSchema = z.object({
    question: z.string().min(1),
    options: z
        .object({
        includeVariants: z.boolean().optional().default(true),
        includeStrongsDefinitions: z.boolean().optional().default(true),
        maxResults: z.number().int().positive().optional().default(10),
        quickMode: z.boolean().optional().default(false), // Fast < 5s response
    })
        .optional(),
});
/**
 * Chat message in a conversation.
 */
export const ChatMessageSchema = z.object({
    role: z.enum(['user', 'assistant']),
    content: z.string(),
});
/**
 * Chat request for multi-turn conversations.
 */
export const ChatRequestSchema = z.object({
    messages: z.array(ChatMessageSchema).min(1),
    contextId: z.string().optional(),
    options: z
        .object({
        verseContext: z
            .object({
            start: z.string(),
            end: z.string().optional(),
        })
            .optional(),
        includeVariants: z.boolean().optional().default(true),
    })
        .optional(),
});
//# sourceMappingURL=query-types.js.map